import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { formatINR } from "@/lib/lamka";

export const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.45 9.45 0 0 1-4.82-1.32l-.35-.2-3.58.94.96-3.49-.23-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.22 4.25-9.46 9.48-9.46a9.42 9.42 0 0 1 9.46 9.47c0 5.22-4.25 9.46-9.46 9.46zm8.05-17.52A11.32 11.32 0 0 0 12.04.65C5.77.65.66 5.75.66 12.03c0 2 .52 3.96 1.52 5.69L.57 23.6l6.03-1.58a11.36 11.36 0 0 0 5.44 1.39h.01c6.27 0 11.38-5.1 11.38-11.38 0-3.04-1.18-5.9-3.34-8.05z" />
  </svg>
);

export const shareLinks = (item) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/product/${item.id}`;
  const text = `${item.title} — ${formatINR(item.price)} on Lamka Online`;
  return { url, text, wa: `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}` };
};

export const ShareButtons = ({ item }) => {
  const { url, text, wa } = shareLinks(item);

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: item.title, text, url });
      } catch {}
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      toast("Link copied");
    } catch {
      toast(url);
    }
  };

  return (
    <div className="flex gap-2">
      <a
        data-testid="share-whatsapp-button"
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 min-h-[44px] px-4 bg-[#25D366] text-[#0F0F0F] text-[10px] tracking-[0.25em] uppercase font-semibold transition-[filter] hover:brightness-95"
      >
        <WhatsAppIcon /> Share on WhatsApp
      </a>
      <button data-testid="share-more-button" aria-label="Share or copy link" onClick={share} className="w-12 min-h-[44px] shrink-0 border border-[#0F0F0F]/20 flex items-center justify-center hover:border-[#0F0F0F] transition-colors">
        <Share2 className="h-4 w-4" strokeWidth={1.5} />
      </button>
    </div>
  );
};
